import { render } from "./AwqaafProductCard.vue?vue&type=template&id=0e35cbb4&scoped=true"
import script from "./AwqaafProductCard.vue?vue&type=script&lang=js"
export * from "./AwqaafProductCard.vue?vue&type=script&lang=js"

import "./AwqaafProductCard.vue?vue&type=style&index=0&id=0e35cbb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35cbb4"]])

export default __exports__